<template>
  <!-- :style="{ height: getVariableTableHeight }" -->
  <div
    id="custom-table-wrap-id"
    class="custom-table-wrap"
    :style="{ maxHeight: getVariableTableHeight }"
    v-if="dataHeader.length > 0 && dataList.length > 0"
    @scroll="onWrapScroll"
    :ref="'tableWrapRef' + tableid"
  >
    <table class="table custom-table" :id="tableid">
      <thead>
        <draggable
          v-model="headers"
          tag="tr"
          :move="handleMove"
          @end="handleDragEnd"
          ghost-class="ghost"
          draggable=".draggableitems"
          handle=".hoveritem"
          @start="onDragStart"
        >
          <th></th>
          <th
            v-for="(header, i) in headers"
            :key="header + 'th-headers' + i"
            :id="header"
            :style="{ width: columnWidth[header] + 'px' }"
            @dragover="dragEnterHandler"
            @dragleave="dragLeaveHandler"
            class="draggableitems"
            scope="custom-table"
          >
            <div class="resizeHandle-before"></div>
            <span class="hoveritem">
              {{ getHeader(header) }}
            </span>
            <div class="resizeHandle"></div>
          </th>
          <th><span class="hoveritem">Erstellt am</span></th>
        </draggable>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in dataList"
          :ref="`tablerow${index}`"
          :key="item.name + 'tr-body-row' + index"
          @mouseenter="getPositionForActionBar(index)"
          :class="{ isrowchecked: isCheckboxChecked(item) }"
          @mouseleave="onTrMouseOut($event, index)"
        >
          <td class="check-box">
            <div class="checker">
              <input
                type="checkbox"
                @click="onCheckBoxClick($event, item)"
                :checked="isCheckboxChecked(item)"
              />
            </div>
            <div
              id="actionToolbarWrapper"
              class="table-action-tools"
              :style="{ top: actionTop + 4 + 'px' }"
              v-show="!isScrolling"
            >
              <slot :loopitems="{ item, index, onDropdownClick }"></slot>
            </div>
            <div v-if="item.loading" class="loadingoverlay">
              <div class="custom-table-progress-icon"></div>
            </div>
          </td>

          <td
            v-for="(header, i) in headers"
            :key="header + 'td-body-content' + i"
          >
            <div
              v-if="isHeaderLink(header)"
              v-html="generateLink(header, item[header])"
            ></div>
            <div v-else-if="isList(item[header])" class="list">
              <img
                class="object-list-icon"
                src="../assets/img/object-list.svg"
                alt="list"
                v-if="item[header].length"
              />
            </div>
            <div v-else class="table-content">
              {{ formatValues(item[header]) }}
            </div>
          </td>
          <td
            v-if="
              item.hasOwnProperty(getSqlKey('created')) &&
              item[getSqlKey('created')] != null
            "
          >
            <div class="table-content">
              {{ getFormattedDate(item) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <slot name="loadmore"></slot>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import { isObjectType } from '../utils/helpers';

export default {
  name: 'CustomTable',
  data() {
    return {
      headers: this.dataHeader,
      columnWidth: this.colWidth,
      futureIndex: null,
      movingIndex: null,
      actionTop: 350,
      isScrolling: false,
      overlayLoaderWidth: 1463,
      startX: 0,
    };
  },
  props: {
    tableid: {
      type: String,
      required: true,
    },
    dataHeader: {
      type: Array,
      required: true,
      default: () => [],
    },
    dataList: {
      type: Array,
      required: true,
    },
    colWidth: {
      type: Object,
      required: true,
    },
    isCheckBoxEnabled: {
      type: Boolean,
      required: true,
    },
    isCheckboxChecked: {
      type: Function,
      required: true,
    },
    getSqlKey: {
      type: Function,
      required: true,
    },
    getHeaderContent: {
      type: Object,
      required: false,
    },
    variableTableHeight: {
      type: Number,
      required: false,
    },
    isHeaderLink: {
      type: Function,
      required: true,
      default: () => {},
    },
    generateLink: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  methods: {
    onDropdownClick(e, index) {
      const tr = this.$refs[`tablerow${index}`][0];

      if (tr) tr.style.zIndex = '3';
    },
    onDragStart(e) {
      this.$refs[`tableWrapRef${this.tableid}`].style.overflowY = 'hidden';
      this.startX = e.originalEvent.clientX;
    },
    onTrMouseOut(e, index) {
      const tr = this.$refs[`tablerow${index}`][0];

      if (tr) {
        tr.style.zIndex = '';
        this.$emit('onTrMouseLeave', index, tr);
      }
    },
    onWrapScroll() {
      this.isScrolling = true;
      let scrollTimer;

      window.clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        this.isScrolling = false;
      }, 400);
    },
    isElementVisibleInViewport(el, container) {
      const headerHeight = document
        .getElementById(this.tableid)
        .querySelector('thead').offsetHeight;
      const containerRect = container.getBoundingClientRect();
      const elementRect = el.getBoundingClientRect();
      const containerTop = containerRect.top + headerHeight;
      const elementTop = elementRect.top - containerTop;
      const elementBottom = elementRect.bottom - containerTop;
      const containerHeight = container.clientHeight - headerHeight;

      return elementTop >= 0 && elementBottom <= containerHeight;
    },
    getPositionForActionBar(e) {
      const tr = this.$refs[`tablerow${e}`][0];
      tr.classList.remove('hide-action-bar');
      const trRect = tr.getBoundingClientRect();
      const tableWrap = document.getElementById('custom-table-wrap-id');

      if (!this.isElementVisibleInViewport(tr, tableWrap)) {
        tr.classList.add('hide-action-bar');
      }

      if (trRect) {
        this.actionTop = trRect.top;
      }
    },
    getFormattedDate(item) {
      let date = this.formatDate(item[this.getSqlKey('created')]);
      return date ? date : '--';
    },
    getHeader(headerName) {
      if (this.getHeaderContent) {
        return this.getHeaderContent[headerName];
      } else {
        return headerName;
      }
    },
    onCheckBoxClick(event, item) {
      this.$emit('onCheckBoxClick', event, item);
    },
    emitUpdateEvent() {
      this.$emit('onDragOrResize', {
        // updatedHeaders: this.headers,
        updatedHeaders: [...this.headers].filter(
          (el) => el !== null && el !== undefined
        ),
        updatedHeadersWidth: this.columnWidth,
      });
    },
    handleDragEnd() {
      this.$refs[`tableWrapRef${this.tableid}`].style.overflowY = 'auto';
      const divs = document.getElementsByClassName('resizeHandle');
      const leftDiv = document.getElementsByClassName('resizeHandle-before');

      for (var i = 0; i < divs.length; i++) {
        divs[i].style.border = 'none';
        leftDiv[i].style.border = 'none';
      }

      if (this.futureIndex !== null && this.movingIndex !== null) {
        // this.futureItem = this.headers[this.futureIndex];
        // this.movingItem = this.headers[this.movingIndex];
        // const _items = Object.assign([], this.headers);
        // _items[this.futureIndex] = this.movingItem;
        // _items[this.movingIndex] = this.futureItem;
        // this.headers = _items;
        // this.emitUpdateEvent();

        // this.futureIndex = null;
        // this.movingIndex = null;

        this.futureItem = this.headers[this.futureIndex];
        this.movingItem = this.headers[this.movingIndex];

        const _items = Object.assign([], this.headers);

        _items.splice(this.movingIndex, 1);
        _items.splice(this.futureIndex, 0, this.movingItem);

        this.headers = _items;
        this.emitUpdateEvent();

        this.futureIndex = null;
        this.movingIndex = null;

        setTimeout(() => {
          this.AddResizerHandle();
        }, 200);
      }
    },
    handleMove(e) {
      const { index, futureIndex } = e.draggedContext;
      const tempFutureIndex =
        futureIndex === 0 ? e.relatedContext.index : futureIndex;

      const finalMoveIndex =
        this.isCheckBoxEnabled && this.isCheckBoxEnabled === true
          ? index - 1
          : index;
      const finalFutureIndex =
        this.isCheckBoxEnabled && this.isCheckBoxEnabled === true
          ? tempFutureIndex - 1
          : tempFutureIndex;

      this.movingIndex = finalMoveIndex;
      this.futureIndex = finalFutureIndex;

      return false;
    },
    setWidth(headerId, width) {
      this.$set(this.columnWidth, headerId, width);
    },
    formatValues(val) {
      const datePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}/gm;
      const datetimePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}/gm;
      if (Array.isArray(val)) {
        return val.join(', ');
      } else if (datetimePat.test(val)) {
        return new Date(val).toLocaleString();
      } else if (datePat.test(val)) {
        return new Date(val).toLocaleString().split(',')[0];
      } else if (isObjectType(val)) {
        return val.name;
      } else {
        return val;
      }
    },
    isList: function (val) {
      return Array.isArray(val) && typeof val[0] !== 'string';
    },
    formatDate(value) {
      if (typeof value === 'string')
        return new Date(Number(value))?.toLocaleString();
      else return new Date(value)?.toLocaleString();
    },
    dragEnterHandler(event) {
      const th = event.target.parentElement;
      const div = th.querySelector('.resizeHandle');
      const leftDiv = th.querySelector('.resizeHandle-before');

      if (event.clientX < this.startX) {
        if (leftDiv) {
          leftDiv.style.borderRight = '5px solid #2383e2';
        }

        if (div) {
          div.style.borderRight = '';
        }
      } else {
        if (div) {
          div.style.borderRight = '5px solid #2383e2';
        }

        if (leftDiv) {
          leftDiv.style.borderRight = '';
        }
      }
    },
    dragLeaveHandler(event) {
      const th = event.target.parentElement;
      const div = th.querySelector('.resizeHandle');
      const leftDiv = th.querySelector('.resizeHandle-before');
      if (div) {
        div.style.borderRight = '';
      }

      if (leftDiv) {
        leftDiv.style.borderRight = '';
      }
    },
    initLoaderPosition() {
      const tablewrap = this.$refs[`tableWrapRef${this.tableid}`];
      const scrollLeftValue = tablewrap.scrollLeft;
      const overlayIcon = document.getElementsByClassName(
        'custom-table-progress-icon'
      );
      const tableWrapCenterWidth = Math.round(tablewrap.offsetWidth / 2);

      if (overlayIcon && overlayIcon.length) {
        for (let index = 0; index < overlayIcon.length; index++) {
          if (document.contains(overlayIcon[index]))
            overlayIcon[index].style.left = `${
              tableWrapCenterWidth + scrollLeftValue
            }px`;

          tablewrap.addEventListener('scroll', function () {
            if (document.contains(overlayIcon[index])) {
              overlayIcon[index].style.left = `${
                this.scrollLeft + tableWrapCenterWidth
              }px`;
            }
          });
        }
      }
    },
    AddResizerHandle() {
      let $vm = this;
      const table = document.getElementById(this.tableid);

      if (table) {
        const resizableColumns = document.querySelectorAll('.draggableitems');

        // const resizerHeight = resizableColumns[0].offsetHeight;

        resizableColumns.forEach((column) => {
          const resizer = column.querySelector('.resizeHandle');

          // eslint-disable-next-line no-unused-vars
          let startX, startWidth, tableWidth, currentHeader;

          resizer.addEventListener('mousedown', (event) => {
            currentHeader = event.target.parentElement;
            startX = event.clientX;
            startWidth = parseInt(getComputedStyle(column).width);
            tableWidth = parseInt(getComputedStyle(column.parentNode).width);

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
          });

          const handleMouseMove = (event) => {
            if (currentHeader) {
              // const table = document.getElementById($vm.tableid);
              const width = startWidth + event.clientX - startX;
              // const newTableWidth = tableWidth + (width - startWidth);
              column.style.width = `${width}px`;
              // table.style.width = `${newTableWidth}px`;

              $vm.setWidth(currentHeader.id, width);
            }
          };

          const handleMouseUp = (e) => {
            e.stopPropagation();
            $vm.emitUpdateEvent();

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
          };
        });
      }
    },
  },
  computed: {
    getVariableTableHeight() {
      if (this.variableTableHeight) {
        return `calc(100vh - ${this.variableTableHeight}px)`;
      } else {
        return `calc(100vh - 100px)`;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.AddResizerHandle();
    }, 1000);
  },
  watch: {
    dataHeader: {
      deep: true,
      handler(newval, oldval) {
        this.headers = newval;
        setTimeout(() => {
          if (newval && oldval) {
            if (
              newval.length > oldval.length ||
              newval.toString() !== oldval.toString()
            ) {
              this.AddResizerHandle();
            }
          }
        }, 1000);
      },
      immediate: true,
    },
  },
  components: {
    draggable,
  },
  emits: ['onDragOrResize', 'onCheckBoxClick'],
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.custom-table-wrap {
  width: 100%;
  overflow: auto;
  padding: 0 2px;
  /* height: calc(100vh - (54px + 18px + 120px + 20px)); */
}

.custom-table {
  border: none;
  width: max-content;
  margin-bottom: 0;
  min-width: 100%;

  border-spacing: 0 8px;
  border-collapse: separate;
}

.custom-table > thead {
  vertical-align: bottom;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f9f9fb;
}

.custom-table tr {
  position: relative;
  transition: all 300ms ease-in-out;
}

.custom-table tbody tr:hover,
.custom-table tbody tr.isrowchecked {
  box-shadow: 0px 2px 5px rgb(80 80 80 / 20%);
  top: -2px;
  /* z-index: 3; */
}

.custom-table tbody .isrowchecked:after {
  content: '';
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  left: -2px;
  top: -2px;
  box-sizing: border-box;
  border: 2px solid #1fc281;
  border-radius: 4px;
  z-index: -1;
}

.custom-table tbody .isrowchecked {
  z-index: 1;
}

.custom-table-wrap .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}
.custom-table-wrap .loadingoverlay .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  top: 5px;
  position: absolute;
  left: 50%;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.custom-table th {
  background: transparent;
  border-bottom: none !important;
  position: relative;
}

.custom-table .draggableitems {
  cursor: grab;
}

.custom-table th {
  font-size: 14px;
  font-weight: 400;
  padding: 0;
  white-space: nowrap;
}

.custom-table td {
  padding: 9px 15px;
  font-size: 12px;
  vertical-align: middle;
  color: #5f697a;
  border-bottom: none;
  border-left: none;
  background: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.custom-table td:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.custom-table td:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.custom-table th:first-child,
.custom-table td:first-child {
  width: 50px;
}

.custom-table td:last-child,
.custom-table th:last-child {
  width: 200px;
}

.custom-table td .table-content {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.custom-table tr:last-child td {
  border-bottom: 1px solid #e7e7e7;
}
.custom-table tr td.check-box {
  min-width: 50px;
  max-width: 50px;
}

.custom-table .ghost {
  background: #dfdfdf80;
  color: black;
}
.custom-table .hoveritem {
  display: flex;
  height: 100%;
  padding: 8px 15px;
  transition: all 300ms ease-in-out;
  color: gray;
}
.custom-table .hoveritem:not(:last-child):hover {
  background: #dfdfdf80;
  color: black;
  transition: all 500ms ease-in-out;
}

.custom-table .checker input,
.custom-table .checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 16px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  margin-bottom: 0;
  accent-color: #53c08a;
  margin-right: 0;
  position: relative;
  top: 2.4px;
}

.custom-table .checker input[type='checkbox']:focus-visible {
  outline: none;
}

.custom-table tr.hide-action-bar .table-action-tools {
  display: none !important;
}

/*Action Tools */
.custom-table tr:hover .table-action-tools {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.custom-table .table-action-tools {
  z-index: 1;
  position: fixed;
  top: 233px;
  right: 55px;
  background: #ffff;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: all 200ms ease-in-out;
  transition: all 400ms ease-in-out;
  min-width: 220px;
  padding-right: 15px;
  pointer-events: none;
}
.table-action-tools ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.table-action-tools ul li {
  margin: 0 5px;
}

.custom-table-wrap .object-list-icon {
  width: 21px;
  height: 21px;
  margin-left: 15px;
}
.custom-table-wrap .object-list-icon {
  width: 21px;
  height: 21px;
}

.resizeHandle {
  position: absolute;
  right: 0;
  top: 0;
  width: 5px;
  cursor: col-resize;
  user-select: none;
  height: 100%;
}

.resizeHandle:hover {
  border-right: 5px solid #2383e2 !important;
}

.resizeHandle-before {
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  user-select: none;
  height: 100%;
}

/* custom scroll bar */

.custom-table-wrap::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.custom-table-wrap::-webkit-scrollbar-track {
  background: #ffff;
  border-radius: 10px;
}

.custom-table-wrap::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 10px;
}

.custom-table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  background-color: white;
}
</style>
